import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { SafeUrlPipeModule } from '../pipes/safe-url.pipe';
import { TranslatePipeModule } from '../shared/translate.pipe';
import { WindowService } from '../shared/window.service';
import { UnitIndexPageComponent } from './unit-index-page/unit-index-page.component';

@NgModule({
  imports: [CommonModule, TranslatePipeModule, SafeUrlPipeModule],
  declarations: [UnitIndexPageComponent],
  providers: [WindowService],
})
export class UnitIndexModule {}



// WEBPACK FOOTER //
// ./ts/app/unit-index/unit-index.module.ts